import {Injectable} from '@angular/core';
import {ProductReviewModalComponent} from "./product-review-modal.component";
import {UsanaObject} from "../usana-object";
import {UrlService} from "../common/url.service";
import {LoggerService} from "../common/logger.service";
import { HttpClient } from '@angular/common/http';
import {ICustomerProductReview, IProductSummary, IShow} from "./product-review.models";
import {IShopUser} from "../session/customer-models";
import {UserService} from "../common/user.service";
import * as _ from 'lodash';
import {AuthUtil} from "../auth/auth-util";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Subject, Subscription} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ProductReviewService extends UsanaObject {

    bsModalRef: BsModalRef;
    productReviewObservable = new Subject();
    productReview: IProductSummary = new IProductSummary();
    customerReview: ICustomerProductReview = new ICustomerProductReview();
    showRateProduct: IShow = {value: false};
    showEditProductReview: IShow = {value: false};

    constructor(
        private urlService: UrlService,
        private http: HttpClient,
        loggerService: LoggerService,
        public modalService: BsModalService,
        private userService: UserService
    ) {
        super(loggerService);
    }

    open(): BsModalRef {
        const initialState = {customerReview: this.customerReview};
        this.bsModalRef = this.modalService.show(ProductReviewModalComponent, Object.assign({}, {
            class: 'product-review-modal',
            initialState
        }));
        const customerReview = this.bsModalRef.content.customerReview;

        const hideModalSubscription: Subscription = this.modalService.onHide.subscribe(() => {
            if (customerReview.rating > 0 && customerReview.rating < 6) {
                customerReview.customerId = this.customerReview.customerId;
                this.postReview(customerReview);
                this.customerReview.rating = customerReview.rating;
            }
            hideModalSubscription.unsubscribe();
        });

        return this.bsModalRef;
    }

    initProductReviews(productId: number, legacyProductId: string) {
        this.resetValues();
        this.getProductReview(productId);
        this.getCustomerProductReview(productId, legacyProductId);
    }

    resetValues() {
        this.customerReview.rating = undefined;
        this.showEditProductReview.value = false;
        this.showRateProduct.value = false;
    }

    getProductReview(productId: number) {

        this.http.get(this.urlService.buildCartUrl("/productReview/productReviewSummary/" + productId))
            .subscribe((response: any) => {
                this.productReview.rating = response.message.rating;
                this.productReview.roundedRating = _.round(response.message.rating * 2) / 2;
                this.productReview.ratingCountDisplay = response.message.ratingCountDisplay;
                this.productReviewObservable.next(this.productReview);
            }, (error: any) => {
                this.log.error("getProductReview", error);
            });
    }

    hasCustomerOrderedProduct(legacyProductId: string): Promise<any> {
        return this.http.get(this.urlService.buildCartUrl("/productReview/hasCustomerOrderedProduct/" + legacyProductId))
            .toPromise()
            .then((response: any) => {
                if (response.success) {
                    return response.message;
                }

            }, (error: any) => {
                this.log.error('error in hasCustomerOrderedProduct', error);
                this.showEditProductReview.value = false;

            });
    }

    getCustomerProductReview(productId: number, legacyProductId: string) {

        this.customerReview.productId = productId;
        this.userService.getShopUserPromise().then((user: IShopUser) => {
            this.customerReview.customerId = user.customer.id;

            const authenticated = AuthUtil.isAuthenticated(user);
            if (authenticated) {
                this.hasCustomerOrderedProduct(legacyProductId).then((response: any) => {
                    if (response == true) {
                        this.showRateProduct.value = authenticated;
                        this.http.get(this.urlService.buildCartUrl("/productReview/customerProductReview/" + productId))
                            .toPromise()
                            .then((response: any) => {
                                if (response.success) {
                                    this.showEditProductReview.value = true;
                                    this.showRateProduct.value = false;
                                    this.customerReview.productId = response.message.productId;
                                    this.customerReview.rating = response.message.rating;
                                }

                            }, (error: any) => {
                                this.log.error('error in getCustomerProductReview', error);
                                this.showEditProductReview.value = false;

                            });
                    }

                }, (error: any) => {
                    this.log.error('error in getCustomerProductReview', error);
                });
            }

        });

    }

    postReview(customerReview: ICustomerProductReview) {

        const body = new ICustomerProductReview();
        body.rating = customerReview.rating;
        body.customerId = customerReview.customerId;
        body.productId = customerReview.productId;

        this.http.post(this.urlService.buildCartUrl("/productReview/"), body)
            .toPromise()
            .then(() => {

                this.showEditProductReview.value = true;
                this.showRateProduct.value = false;
                this.getProductReview(customerReview.productId);
            }, (error: any) => {
                this.log.error("postReview", error);
            });
    }
}
